<template>
	<div
		class="flex items-center justify-center transition"
		:class="[variantClasses, sizeClasses, paletteClasses]"
	>
		<AppIcon :name="icon" />
	</div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Props {
	variant?: "circle" | "square";
	size?: "md";
	icon: string;
	palette?: "purple" | "gray" | "red";
}
const props = withDefaults(defineProps<Props>(), {
	variant: "circle",
	size: "md",
	palette: "gray",
});
const variantClasses = computed(() => ({
	"rounded-full": props.variant === "circle",
	rounded: props.variant === "circle",
}));
const sizeClasses = computed(() => ({
	"size-8 text-xl": props.size === "md",
}));
const paletteClasses = computed(() => ({
	"bg-gray-100 text-[var(--text-secondary)]": props.palette === "gray",
	"bg-purple-100 text-accent-primary": props.palette === "purple",
	"bg-red-100 text-red-800": props.palette === "red",
}));
</script>
